module.exports = __webpack_public_path__ + "assets/img/house.cef6fecb.webp";